import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Highlight from './Highlight';
import joyrideStore from './JoyrideStore';
import JoyridePrompt from './JoyridePrompt';
import { useEffect } from 'react';
export default function JoyrideContainer() {
    const [highlightProps, setHighlightProps] = useState({
        target: undefined,
    });
    const [promptProps, setPromptProps] = useState({});
    const [active, setActive] = useState(false);
    useEffect(() => {
        joyrideStore.registerSetHighlightProps(setHighlightProps);
        joyrideStore.registerSetPromptProps(setPromptProps);
        joyrideStore.registerSetActive(setActive);
    }, []);
    if (!active) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Highlight, { ...highlightProps }), _jsx(JoyridePrompt, { ...promptProps })] }));
}
//# sourceMappingURL=JoyrideContainer.js.map